import React, { Component } from "react";
import TableBox from "./Table/TableBox";
import {
    MITARBEITER_ARCHIVE,
  MITARBEITER_UEBERSICHT,
} from "../utils/TableConstanten";

export default class ReportMitarbeiterBox extends Component {
  constructor(props) {
    super(props);
    this.reportSchema = {
      type: "object",
      properties: {},
    };
  }

  validate(props) {}

  componentDidMount() {
    this.validate(this.props);
    // this.props.changeTitle("Vorsorge");
  }

  componentDidUpdate(newProps) {
    if (newProps !== this.props) {
      this.validate(newProps);
    }
  }

  componentWillUnmount() {
    this.props.changeTitle(null);
  }

  render() {
    const { is_archived, setCsvQuery } = this.props;
    // je nachdem Titel und Resource-Name wählen
    const title = is_archived ? "Archivierte Mitarbeiter" : "Mitarbeiter Übersicht";
    const resourceName = is_archived ? MITARBEITER_ARCHIVE : MITARBEITER_UEBERSICHT;
    return (
      <TableBox
        title={title}
        resourceName={resourceName}
        schema={this.reportSchema}
        setCsvQuery={setCsvQuery}
        rowClicks
        report={!is_archived}
        archive={is_archived}
      />
    );
  }
}
